export const ToDesktopAppMenuEventNames = {
    OpenPlanner: "open-planner",
    OpenFocusMode: "open-focus-mode",
} as const;
